// Mood records currently use UTC calendar dates as their storage keys.
export function recentMoodEntries(checkins, days = 7, now = new Date()) {
  const today = now.toISOString().slice(0, 10);
  const cutoff = new Date(`${today}T00:00:00.000Z`);
  cutoff.setUTCDate(cutoff.getUTCDate() - days + 1);
  const firstDay = cutoff.toISOString().slice(0, 10);
  return Object.entries(checkins || {})
    .filter(([date, entry]) => date >= firstDay && date <= today && Number.isFinite(entry?.rating))
    .sort(([a], [b]) => b.localeCompare(a));
}
